<template>
  <section>
    <v-row align="center" style="max-height: 56px" class="mr-2">
      <v-col cols="auto">
        <v-menu v-model="menu" :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              :disabled="filteredTags.length === 0"
              :text="filteredTags.length === 0"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              {{ $t("profile.mentorship.start") }}
              <v-badge
                v-if="filteredTags.length > 0"
                :content="filteredTags.length"
                color="warning"
                class="ml-2"
              >
              </v-badge>
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="tag in filteredTags"
              :key="tag.id"
              @click="assign(tag)"
            >
              <v-list-item-content>
                <v-list-item-title>{{
                  tag.description || tag.name
                }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="ignore(tag)"
                    >
                      <v-icon>delete_forever</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("profile.mentorship.ignore.title") }}</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <employee-selector
      :title="$t('profile.mentorship.assign.create.title')"
      :show.sync="mentorSelector.show"
      @change="mentorSelector.callback"
    />
    <revoke-modal
      v-if="ignoreDialog.show"
      :show="ignoreDialog.show"
      :title="$t(`profile.mentorship.ignore.title`)"
      :text="$t(`profile.mentorship.ignore.text`)"
      :action="$t(`profile.mentorship.ignore.action`)"
      @confirm="ignoreDialog.callback"
      @cancel="ignoreDialog.show = false"
    />
  </section>
</template>

<script>
import EmployeeSelector from "@/components/EmployeeSelector";
import RevokeModal from "@/components/RevokeModal";

import AssignMentorshipQuery from "@/graphql/AssignMentorship.gql";
import IgnoreMentorshipQuery from "@/graphql/mutation/mentorship/IgnoreMentorship.gql";

export default {
  components: {
    EmployeeSelector,
    RevokeModal,
  },
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      menu: false,
      mentorSelector: {
        show: false,
        oldTag: null,
        callback: () => {},
      },
      ignoreDialog: {
        show: false,
        callback: () => {},
      },
    };
  },
  computed: {
    filteredTags() {
      return this.employee.tags.filter(
        (tag) =>
          ["position", "department", "location"].includes(tag.category) &&
          !tag.mentorshipIgnore &&
          !this.employee.mentorships.some(
            (mentorship) => mentorship.tag && mentorship.tag.id === tag.id
          )
      );
    },
  },

  methods: {
    assign(tag, id) {
      if (typeof id === "undefined") {
        this.mentorSelector = {
          show: true,
          callback: (id) => this.assign(tag, id),
        };
      } else {
        this.$apollo
          .mutate({
            mutation: AssignMentorshipQuery,
            variables: {
              employeeId: this.employee.id,
              tagId: tag.id,
              mentorId: id,
            },
          })
          .then(() => {
            this.$emit("refresh");
          })
          .catch((err) => {
            this.$store.commit("push_global_message", {
              color: "error",
              text: err,
            });
          })
          .finally(() => {
            this.mentorSelector = {
              show: false,
              callback: () => {},
            };
          });
      }
    },
    ignore(tag, args) {
      if (!args) {
        this.ignoreDialog = {
          callback: (args) => this.ignore(tag, args),
          show: true,
        };
      } else {
        this.ignoreDialog = {
          callback: () => {},
          show: false,
        };

        this.$apollo
          .mutate({
            mutation: IgnoreMentorshipQuery,
            variables: {
              tagId: tag.id,
              employeeId: this.employee.id,
              reason: args.reason,
            },
          })
          .then(() => {
            this.$emit("refresh");
          })
          .catch((err) => {
            this.$store.commit("push_global_message", {
              color: "error",
              text: err,
            });
          });
      }
    },
  },
};
</script>

<style scoped></style>
